import { QuestDifficulty } from './types';

export const mapDifficultyToXp = (difficulty: QuestDifficulty) => {
    switch(difficulty) {
        case QuestDifficulty.NoEffort: return 1;
        case QuestDifficulty.Easy: return 5;
        case QuestDifficulty.Medium: return 10;
        case QuestDifficulty.Challenging: return 20;
        case QuestDifficulty.Hardcore: return 40;
        default: return 0;
    }
} 